export const ROLLOUTS = {
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
    LYNXES_TIKTOK_SHOP_SERVICE: 'lynxes_tiktok_shop_service',
    LYNXES_LOHP_SANDBOX_GUARDRAIL: 'lynxes_lohp_sandbox_guardrail',
    LYNXES_LOHP_BELOW_THE_FOLD: 'lynxes_lohp_below_the_fold',
};
